import React, { useState } from 'react';
import axios from 'axios';
import { AJAX_URL } from '../../../config/index.js';

const RegisterForm = ({ onRegisterSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleRegister = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    if (!isPasswordStrong(password)) {
      setPasswordError('Password is not strong enough.');
      setLoading(false);
      return;
    }

    if (!isEmailValid(email)) {
      setEmailError('Invalid email format.');
      setLoading(false);
      return;
    }

    const formData = new URLSearchParams();
    formData.append('action', 'fl_create_account');
    formData.append('email', email);
    formData.append('password', password);

    try {
      const response = await axios({
        method: 'post',
        url: AJAX_URL,
        data: formData,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });

      if (response.data.success) {
        onRegisterSuccess(response.data.data.username);
      } else {
        setError(response.data.data);
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
    }

    setLoading(false);
  };

  const isPasswordStrong = (password) => {
    const minLength = 8;
    return password.length >= minLength;
  };

  const isEmailValid = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setPassword(newPassword);
    if (!isPasswordStrong(newPassword)) {
      setPasswordError('Password must be at least 8 characters long.');
    } else {
      setPasswordError('');
    }
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (!isEmailValid(newEmail)) {
      setEmailError('Invalid email format.');
    } else {
      setEmailError('');
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <form className="fuselight-register-form" onSubmit={handleRegister}>
      <div>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={handleEmailChange}
          required
          autoComplete="email"
        />
      </div>
      {emailError && <p className="email-error">{emailError}</p>}
      <div className="password-field">
        <label>Password:</label>
        <div style={{ position: 'relative' }}>
          <input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={handlePasswordChange}
            required
            autoComplete="new-password"
          />
          <span onClick={togglePasswordVisibility}>
            {showPassword ? 'Hide' : 'Show'}
          </span>
        </div>
      </div>
      {passwordError && <p className="password-error">{passwordError}</p>}
      <div>
        <button type="submit" disabled={loading}>
          {loading ? 'Creating...' : 'Create Account'}
        </button>
      </div>
      {error && <p className="error-message">{error}</p>}
    </form>
  );
};

export default RegisterForm;
